module.exports = {"id":"dp3_4l1q5","text":"Computational Thinking and Programming","instructions":"Which option best represents a simple symbolic sequence used to give instructions?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.4","questionType":"PickOne","random":true,"options":[{"id":"dp3_4l1q5-a1","text":"Step one then step two then step three","score":1.8},{"id":"dp3_4l1q5-a2","text":"A paragraph describing a task in detail","score":0},{"id":"dp3_4l1q5-a3","text":"An image without explanatory labels","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.4/l1q5.json
// module id = 1179
// module chunks = 41